<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="text-center">
                <h1>PROCESSING OPTIONS</h1>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

//########################################
//IMPORTS libs
//########################################
import {Facade_Logger} from '@/libs/facades/facade_logger.js';
import {Facades_Apps_Urls} from '@/libs/links/links_to_pages.js';

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################

export default {
  name: 'ModuleCorePageIndex',

    props:[
    ],

    created:function()
    {
        action_on_page_load.call(this);
    },

    components: {
    },

    data: function()
    {
        return {}
    },

    computed:{
        //============================
        //LOCAL COMPUTED
        //============================

        //============================
        //VUEX COMPUTED HELPERS
        //============================
        ...mapGetters(
            {
                data_form_view: 'data_form_view_getstate_all'
            }
        )
    }
};

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

/**
 * clear the inputs_validation/flash messages
 * 
 * by setting the label-attrs to null
*/
function helper_clear_flash_messages()
{
    //OBJ CONTEXT
    var self=this;
    
    return self.$store.dispatch(
        'component_alert_flash_action_toggle',
        {
            show:false,
            modal:false,
            type:"",
            heading:"",
            message:""
        }
    );
}

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################

/**
 * default action when page loads
 * do initialization here
*/
function action_on_page_load()
{
    //OBJ CONTEXT
    var self=this;

    helper_clear_flash_messages.call(self).then(
        function()
        {
            return self.$store.dispatch(
                'component_alert_flash_action_toggle',
                {
                    show:true,
                    modal:false,
                    type:"info",
                    heading:"LOADING",
                    message:"loading data"
                }
            );
        }
    ).then(
        function()
        {
            return self.$store.dispatch(
                'data_form_view_action_set_all',
                {
                    username:self.$route.params.username,
                    form_name:self.$route.params.form_name,
                    form_id:self.$route.params.form_id
                }
            );
        }
    ).then(
        function()
        {
            if(ENGINES_selector.check_form_name_enabled(self.$route.params.form_name))
            {
                //=================================================
                //NAVIGATE TO FORM INDEX PAGE
                //=================================================

                ENGINES_selector.navigate_to_form_page_index(
                    self.$route.params.form_name,
                    Facades_Apps_Urls.module_addon_form_bhcpf_page_srp(
                        self.$route.params.username,
                        self.$route.params.form_name,
                        self.$route.params.form_id
                    ),
                    Facades_Apps_Urls.module_addon_form_primary_iss_page_srp(
                        self.$route.params.username,
                        self.$route.params.form_name,
                        self.$route.params.form_id
                    ),
                    Facades_Apps_Urls.module_addon_form_nhmis_dqa_odk_page_srp(
                        self.$route.params.username,
                        self.$route.params.form_name,
                        self.$route.params.form_id
                    ),
                )
            }
            else
            {
                self.$store.dispatch(
                    'component_alert_flash_action_toggle',
                    {
                        show:true,
                        modal:true,
                        type:"warning",
                        heading:"FORM LOAD ERROR",
                        message:"sorry,the form you tried to load is not allowed"
                    }
                );
            }
        }
    ).catch(
        function(err)
        {
            Facade_Logger.log("prom error catch=>"+err);

            //alert error
            return self.$store.dispatch(
                'component_alert_flash_action_toggle',
                {
                    show:true,
                    modal:true,
                    type:"warning",
                    heading:"SORRY,SOMETHING WENT WRONG,our enginners have been notified",
                    message:err
                }
            );
        }
    );
}
</script>
